export type HeadingReadBounds = Pick<DOMRectReadOnly, 'x' | 'y' | 'left' | 'right' | 'top' | 'bottom' | 'width' | 'height'> & { rightmost?:number };

/** The guide rises beside the last line, leaving the content below unobstructed. */
export function headingRestPoint(bounds: HeadingReadBounds, width: number, height: number): { x: number; y: number } {
  return { x: Math.min(width - 42, (bounds.rightmost??bounds.right) + 48), y: Math.min(height - 48, bounds.top + bounds.height * .5) };
}

/** The guide reads beneath the final text line, not the heading's layout box. */
export function headingReadBounds(element: Element | null): HeadingReadBounds | undefined {
  if (!element) return undefined;
  const fallback = element.getBoundingClientRect();
  const document = element.ownerDocument;
  if (typeof document?.createRange !== 'function') return fallback;
  try {
    const range = document.createRange();
    range.selectNodeContents(element);
    const rects = [...range.getClientRects()].filter(rect =>
      rect.width > 0 && rect.height > 0 &&
      [rect.left, rect.right, rect.top, rect.bottom].every(Number.isFinite));
    if (!rects.length) return fallback;
    const bottom = Math.max(...rects.map(rect => rect.bottom));
    // Adjacent inline fragments may have fractional baseline differences.
    const line = rects.filter(rect => bottom - rect.bottom <= 2);
    const left = Math.min(...line.map(rect => rect.left));
    const right = Math.max(...line.map(rect => rect.right));
    const top = Math.min(...line.map(rect => rect.top));
    const rightmost=Math.max(...rects.map(rect=>rect.right));
    return { x: left, y: top, left, right, top, bottom, width: right - left, height: bottom - top, ...(rightmost>right?{rightmost}:{}) };
  } catch {
    // Partial DOM environments need the same safe fallback as an empty heading.
    return fallback;
  }
}
